import {
  CarnetDeNotes,
  CarnetDeNotesApi,
  CarnetDeNotesPrint,
  CarnetDeNotesPrintApi,
  Evaluation,
  EvaluationApi,
} from '@teetsh/app/src/containers/CarnetsDeNotes/types/carnetsDeNotes';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import { PourcentagesNotation } from '@teetsh/app/src/utils/notationSystems/notationSystems';
import parseISO from '@teetsh/app/src/utils/time/parseISO';
import formatISO from '@teetsh/app/src/utils/time/formatISO';

export function serializeCdn(cdn: CarnetDeNotes) {
  return cdn;
}

export function deserializeEvaluation(evaluation: EvaluationApi): Evaluation {
  return {
    ...evaluation,
    createdAt: evaluation.createdAt
      ? parseISO(evaluation.createdAt)
      : undefined,
    date: evaluation.date ? parseISO(evaluation.date) : undefined,
    notes: (evaluation.notes || []).map(n => ({
      ...n,
      evaluationId: evaluation.id,
    })),
  };
}

export function deserializeCdn(
  cdn: CarnetDeNotesApi,
  notationSystems: { [key: string]: NotationSystem },
): CarnetDeNotes {
  return {
    ...cdn,
    notationSystem:
      notationSystems[cdn.notationSystemId] || PourcentagesNotation,
  };
}

export function deserializeCdnPrint(
  cdn: CarnetDeNotesPrintApi,
  notationSystem: NotationSystem,
): CarnetDeNotesPrint {
  return {
    ...cdn,
    evaluations: (cdn.evaluations || []).map(ev => deserializeEvaluation(ev)),
    notationSystem,
  };
}

export function serializeEvaluation(ev: Evaluation) {
  const { ...evaluation } = ev;
  return {
    ...evaluation,
    createdAt: evaluation.createdAt
      ? formatISO(evaluation.createdAt)
      : undefined,
    date: evaluation?.date ? formatISO(evaluation.date) : null,
  };
}
